"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedFulfillmentProductResponseWithCount = exports.mockedFulfillmentProductResponse = exports.mockedFulfillmentProductUpdateRequest = exports.mockedFulfillmentProductCreateRequest = void 0;
const date_util_1 = require("../../utils/date.util");
const fulfillment_1 = require("../fulfillment");
const product_1 = require("../product");
exports.mockedFulfillmentProductCreateRequest = {
  fulfillmentId: 1,
  productId: 1,
  externalId: '12345',
  sku: 'SKU123'
};
exports.mockedFulfillmentProductUpdateRequest = {
  qtySent: 10,
  qtyStock: 90
};
exports.mockedFulfillmentProductResponse = {
  id: 1,
  fulfillment: fulfillment_1.mockedFulfillmentResponse,
  product: product_1.mockedProductResponse,
  externalId: '12345',
  sku: 'SKU123',
  qtySent: 0,
  qtyStock: 0,
  packages: [],
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null
};
exports.mockedFulfillmentProductResponseWithCount = {
  items: [exports.mockedFulfillmentProductResponse],
  count: 1
};